/**
 * @generated SignedSource<<66685deac297bf689ec41b0ccf0b9660>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraJQLBuilderSearchMode = "ADVANCED" | "BASIC" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type JQLBuilderUI_userPreferences$data = {
  readonly jqlBuilderSearchMode: JiraJQLBuilderSearchMode | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useSearchModeMutation">;
  readonly " $fragmentType": "JQLBuilderUI_userPreferences";
};
export type JQLBuilderUI_userPreferences$key = {
  readonly " $data"?: JQLBuilderUI_userPreferences$data;
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderUI_userPreferences">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JQLBuilderUI_userPreferences",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "useSearchModeMutation"
    },
    {
      "kind": "ScalarField",
      "name": "jqlBuilderSearchMode"
    }
  ],
  "type": "JiraUserPreferences"
};

(node as any).hash = "d1a3ad4229370b1f3207a1d37676c830";

export default node;
